import { FLAGS, useFlag } from '@iheartjane/feature-flags';

/**
 * Checks if the store is enabled for store refresh.
 *
 * Uses context to determine if the store is enabled for store refresh.
 * @returns True if the store is enabled for store refresh, false otherwise.
 */
export const useIsStoreRefreshEnabled = (): boolean => {
  return useFlag(FLAGS.dmAutoRefreshEnabled, false);
};
